module.exports = __webpack_public_path__ + "static/media/garrafa.223a8ae8.png";